import { createRootRoute, Link, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { Button } from '@journ/ui/button'
import { NuqsAdapter } from 'nuqs/adapters/tanstack-router'
import { ThemeProvider } from '@/features/theme/ui/theme-provider'
import { LocaleProvider } from '@/features/i18n/ui/locale-provider'
import { Toaster } from '@/features/notifications/ui/toaster'

function NotFound() {
	return (
		<div className='min-h-screen flex items-center justify-center'>
			<div className='max-w-md w-full text-center px-4'>
				<p className='text-878787 text-sm mb-2'>404</p>
				<h2 className='font-medium mb-4'>Page not found</h2>
				<p className='text-sm text-878787 mb-8'>The page you're looking for doesn't exist or has been moved.</p>
				<Button asChild variant='outline'>
					<Link to='/'>Go home</Link>
				</Button>
			</div>
		</div>
	)
}

export const Route = createRootRoute({
	notFoundComponent: NotFound,
	component: () => (
		<NuqsAdapter>
			<LocaleProvider>
				<ThemeProvider>
					<Outlet />
					<Toaster />
					{import.meta.env.DEV && <TanStackRouterDevtools />}
				</ThemeProvider>
			</LocaleProvider>
		</NuqsAdapter>
	),
})
